import bikiniBefore from '../../../../images/lp/googleV2/treatmentareas_bikinibefore.webp';
import bikiniAfter from '../../../../images/lp/googleV2/treatmentareas_bikiniafter.webp';
import underarmBefore from '../../../../images/lp/googleV2/treatmentareas_underarmbefore.webp';
import underarmAfter from '../../../../images/lp/googleV2/treatmentareas_underarmafter.webp';
import brazilianImg from '../../../../images/lp/googleV2/treatmentareas_brazilian.webp';
import legsBefore from '../../../../images/lp/googleV2/treatmentareas_legsbefore.webp';
import legsAfter from '../../../../images/lp/googleV2/treatmentareas_legsafter.webp';
import faceBefore from '../../../../images/lp/googleV2/treatmentareas_lipsbefore.webp';
import faceAfter from '../../../../images/lp/googleV2/treatmentareas_lipsafter.webp';
import fullBodyImg from '../../../../images/lp/googleV2/treatmentareas_fullbody.webp';
import armsBefore from '../../../../images/lp/googleV2/treatmentarea-armsbefore.webp';
import armsAfter from '../../../../images/lp/googleV2/treatmentarea-armsafter.webp';
import stomachBefore from '../../../../images/lp/googleV2/treatmentareas-stomachbefore.webp';
import stomachAfter from '../../../../images/lp/googleV2/treatmentarea-stomachafter.webp';
import buttImg from '../../../../images/lp/googleV2/treatmentareas-ButtAfter.webp';
import handsImg from '../../../../images/lp/googleV2/treatmentareas-hands-1pic.webp';

const treatmentsData = [
    {
        id: 'bikini',
        title: 'Bikini',
        desc: 'Safe & effective way to remove unwanted hair and get a smooth bikini line',
        before: bikiniBefore,
        after: bikiniAfter,
        showBeforeAfter: true,
    },
    {
        id: 'underarms',
        title: 'Underarms',
        desc: 'Say goodbye to coarse hair, itchy pits, and prickly unwanted hair',
        before: underarmBefore,
        after: underarmAfter,
        showBeforeAfter: true,
    },
    {
        id: 'brazilian',
        title: 'Brazilian',
        desc: 'Treat your most sensitive areas to remove hair front and back',
        before: brazilianImg,
        showBeforeAfter: false,
    },
    {
        id: 'legs',
        title: 'Legs',
        desc: 'Get impossibly smooth legs free of bumps, razor burn, cuts, and prickly hair',
        before: legsBefore,
        after: legsAfter,
        showBeforeAfter: true,
    },
    {
        id: 'face',
        title: 'Face',
        desc: 'Customize your treatment from your forehead to your lip, chin, and neck',
        before: faceBefore,
        after: faceAfter,
        showBeforeAfter: true,
    },
    {
        id: 'fullbody',
        title: 'Full Body',
        desc: 'Treating all body areas at once is cost-effective',
        before: fullBodyImg,
        showBeforeAfter: false,
    },
    {
        id: 'buttocks',
        title: 'Buttocks',
        desc: 'The safest & most effective way to remove hair on the cheeks and the perirectal area',
        before: buttImg,
        showBeforeAfter: false,
    },
    {
        id: 'arms',
        title: 'Arms',
        desc: 'Customize your treatment plan to full arm, lower arm or upper arm',
        before: armsBefore,
        after: armsAfter,
        showBeforeAfter: true,
    },
    {
        id: 'stomach',
        title: 'Stomach',
        desc: 'Safely treat “happy trails” and stubborn stomach hair',
        before: stomachBefore,
        after: stomachAfter,
        showBeforeAfter: true,
    },
    {
        id: 'feethands',
        title: 'Feet & Hands',
        desc: 'Most effective way to get rid of unwanted hair on the top of the hand, knuckles, toes, and feet',
        before: handsImg,
        showBeforeAfter: false,
    },
];

export default treatmentsData;
